import { useRouteMatch } from 'react-router-dom';
import { routeToModuleTypeMap } from '../constants/sidebar.constants';

export const useModuleType = (specificRoute = null) => {
  const { path } = useRouteMatch();
  const moduleType = routeToModuleTypeMap[specificRoute || path];

  return moduleType || null;
};
